// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const it: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'Come si gioca',
  'howto.pieces.heading': 'I pezzi',
  'howto.pieces.source': 'Sorgente',
  'howto.pieces.mirror': 'Specchio',
  'howto.pieces.switch': 'Interruttore',
  'howto.pieces.exit': 'Uscita',
  'howto.pieces.wall': 'Muro',
  'howto.controls.heading': 'I comandi',
  'howto.controls.clickSlot.line1': 'Clicca la casella',
  'howto.controls.clickSlot.line2': 'piazza lo specchio',
  'howto.controls.dragMirror.line1': 'Trascina lo specchio',
  'howto.controls.dragMirror.line2': 'ruota',
  'howto.controls.rightClick.line1': 'Tasto destro',
  'howto.controls.rightClick.line2': 'togli lo specchio',
  'howto.controls.hint':
    'Rotellina del mouse: rotazione fine di 1°.   Tocca lo specchio: rotazione di 15°.',
  'howto.objective.line1': 'Accendi ogni interruttore — il blocco dell’uscita si apre.',
  'howto.objective.line2': 'Poi clicca l’uscita. Risolvi con meno specchi possibile.',

  'howtoColor.title': 'Colore e prismi',
  'howtoColor.pieces.heading': 'Nuovi pezzi',
  'howtoColor.pieces.prism': 'Prisma',
  'howtoColor.pieces.redSwitch': 'Interruttore rosso',
  'howtoColor.pieces.yellowSwitch': 'Interruttore giallo',
  'howtoColor.pieces.whiteSwitch': 'Interruttore bianco',
  'howtoColor.how.heading': 'Come funzionano',
  'howtoColor.how.line1': 'Un raggio bianco porta luce rossa, verde e blu insieme.',
  'howtoColor.how.line2':
    'Un prisma divide la luce bianca in tre raggi colorati sui suoi tre lati.',
  'howtoColor.how.line3': 'Clicca un prisma piazzato per ruotare la sua faccia di entrata.',
  'howtoColor.switches.line1':
    'Gli interruttori mostrano punti colorati — è il colore che chiedono.',
  'howtoColor.switches.line2':
    'Un interruttore giallo (punti rosso + verde) ha bisogno di entrambi i colori.',
  'howtoColor.switches.line3':
    'Un interruttore bianco (tutti e tre) ha bisogno di rosso, verde E blu insieme.',

  'options.hints.label': 'Mostra gli angoli di aiuto nei puzzle',
  'options.hints.help':
    'Mostra l’angolo tra il raggio in arrivo e quello riflesso a ogni rimbalzo.',

  'level.01-intro.title': 'Ciao, luce',
  'level.02-two-mirrors.title': 'Due svolte',
  'level.03-corner.title': 'Muro sulla strada',
  'level.04-two-targets.title': 'Due bersagli',
  'level.05-tight.title': 'Stretto',
  'level.06-hello-color.title': 'Ciao, colore',
  'level.07-pick-a-side.title': 'Scegli un lato',
  'level.08-yellow.title': 'Giallo',
  'level.09-magenta.title': 'Magenta',
  'level.10-spectrum.title': 'Spettro',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'retto',
  'puzzle.hint.angleType.acute': 'acuto',
  'puzzle.hint.angleType.obtuse': 'ottuso',
  'puzzle.hint.label': '{angle}°\n{type}',
};
